/**
 * 正则表达式
 */
export const phoneReg = /^(13[0-9]|14[5-9]|15[012356789]|166|17[0-8]|18[0-9]|19[8-9])[0-9]{8}$/; // 密码至少包含 数字和英文，长度4-12